<agpr-button
    class="agpr-optionalMediaTypeField-selectToggle"
    [style]="buttonTypes.link"
    [label]="allSelected ? 'selectNone' : 'selectAll'"
    (click)="toggleSelectAll()"
></agpr-button>

<div
    class="agpr-formField agpr-optionalMediaTypeField"
    role="group"
    [attr.aria-labelledby]="field.headingId"
>
    <agpr-panel
        [id]="id + '_standardTypes'"
        class="agpr-optionalMediaTypeField-panel"
        [header]="'Report.userPreferences.defaultColors.media'"
    >
        <div class="agpr-optionalMediaTypeField-panel-column">
            <div
                *ngFor="
                    let color of mediaTypeColors;
                    let index = index
                "
                class="agpr-optionalMediaTypeField-item"
                role="group"
            >
                <agpr-checkbox
                    [id]="id + '_mediaTypeColor' +'_checkbox_' + index"
                    [label]="color.label"
                    [binary]="true"
                    [(ngModel)]="valueMap[color.key]"
                    (ngModelChange)="handleChanges()"
                ></agpr-checkbox>
                <agpr-chart-color-picker-field
                    [disabled]="!valueMap[color.key]"
                    [id]="id + '_mediaTypeColor_' + index"
                    [field]="color"
                    [userPreferenceColor]="color.userPreferenceColor"
                    [block]="block"
                    [doBorder]="true"
                    (changes)="emitChanges($event)"
                    [ariaLabel]="
                        color.label +
                        ' ' +
                        ('Reports.formfield.metadata.colorSelection' | localize)
                    "
                ></agpr-chart-color-picker-field>
            </div>
        </div>
    </agpr-panel>

    <agpr-panel
        [id]="id + '_coreSocialTypes'"
        class="agpr-optionalMediaTypeField-panel"
        [header]="'Report.userPreferences.socialColors.media'"
    >
        <div class="agpr-optionalMediaTypeField-panel-column">
            <div
                *ngFor="
                    let color of coreSocialColors;
                    let index = index
                "
                class="agpr-optionalMediaTypeField-item"
                role="group"
            >
                <agpr-checkbox
                    [id]="id + '_socialColor' + '_checkbox_' + index"
                    [label]="color.label"
                    [binary]="true"
                    [(ngModel)]="valueMap[color.key]"
                    (ngModelChange)="handleChanges()"
                ></agpr-checkbox>
                <agpr-chart-color-picker-field
                    [disabled]="!valueMap[color.key]"
                    [id]="id + '_socialColor_' + index"
                    [field]="color"
                    [userPreferenceColor]="color.userPreferenceColor"
                    [block]="block"
                    [doBorder]="true"
                    (changes)="emitChanges($event)"
                    [ariaLabel]="
                        color.label +
                        ' ' +
                        ('Reports.formfield.metadata.colorSelection' | localize)
                    "
                ></agpr-chart-color-picker-field>
            </div>
        </div>
    </agpr-panel>

    <agpr-panel
        [id]="id + '_otherSocialTypes'"
        class="agpr-optionalMediaTypeField-panel"
        [header]="'Report.userPreferences.otherColors.media'"
        [collapsed]="true"
    >
        <div class="agpr-optionalMediaTypeField-panel-column">
            <div
                *ngFor="
                    let color of otherSocialColors;
                    let index = index
                "
                class="agpr-optionalMediaTypeField-item"
                role="group"
            >
                <agpr-checkbox
                    [id]="id + '_otherSocialColor' + '_checkbox_' + index"
                    [label]="color.label"
                    [binary]="true"
                    [(ngModel)]="valueMap[color.key]"
                    (ngModelChange)="handleChanges()"
                ></agpr-checkbox>
                <agpr-chart-color-picker-field
                    [disabled]="!valueMap[color.key]"
                    [id]="id + '_otherSocialColor_' + index"
                    [field]="color"
                    [userPreferenceColor]="color.userPreferenceColor"
                    [block]="block"
                    [doBorder]="true"
                    (changes)="emitChanges($event)"
                    [ariaLabel]="
                        color.label +
                        ' ' +
                        ('Reports.formfield.metadata.colorSelection' | localize)
                    "
                ></agpr-chart-color-picker-field>
            </div>
        </div>
    </agpr-panel>
</div>
